import { render } from "./FlipCard.vue?vue&type=template&id=6ea225d3&scoped=true"
import script from "./FlipCard.vue?vue&type=script&lang=js"
export * from "./FlipCard.vue?vue&type=script&lang=js"

import "./FlipCard.vue?vue&type=style&index=0&id=6ea225d3&scoped=true&lang=less"
script.render = render
script.__scopeId = "data-v-6ea225d3"

export default script